export const CHAT_DETAIL_ACTIVE_SET = "CHAT_DETAIL_ACTIVE_SET" as const;
export const CHAT_DETAIL_SET = "CHAT_DETAIL_SET" as const;
export const CHAT_FAVORITE_ALL_SET = "CHAT_FAVORITE_ALL_SET" as const;
export const CHAT_INPUT_FIELD_SAVE = "CHAT_INPUT_FIELD_SAVE" as const;
export const CHAT_RESET = "CHAT_RESET" as const;
export const CHAT_ROOM_ALL_SET = "CHAT_ROOM_ALL_SET" as const;
export const CHAT_ROOM_SET = "CHAT_ROOM_SET" as const;
export const CHAT_SETTING_SET = "CHAT_SETTING_SET" as const;
